<template>
  <div>
    <el-breadcrumb separator-icon="ArrowRight" style="margin: 16px">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>宿舍管理</el-breadcrumb-item>
      <el-breadcrumb-item>房间面板</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin: 15px; min-height: calc(100vh - 111px)" ref="panelContainer" class="room-panel-card">
      <div>
        <!--    功能区-->
        <div style="margin: 10px 0" class="panel-toolbar">
          <!--    搜索区-->
          <div style="margin: 10px 0" class="panel-search">
            <el-form :inline="true" class="demo-form-inline panel-search-form">
              <el-form-item label="楼宇号:" class="build-select-item">
                <el-select v-model="dormBuildId" placeholder="请选择" style="width: 250px">
                  <el-option :label="item.dormBuildName + (item.dormBuildDetail ? '-' + item.dormBuildDetail : '')" :value="item.id"
                    v-for="item in buildingOpts" />
                </el-select>
              </el-form-item>
              <el-form-item class="build-btn-item">
                <el-button icon="Search" style="margin-left: 5px" type="primary" @click="load"></el-button>
                <el-button icon="refresh-left" style="margin-left: 10px" type="default" @click="reset"></el-button>
              </el-form-item>
              <div style="float: right; display: flex; align-items: center; gap: 8px;" class="build-actions">
                <!-- 全屏模式下快速切换楼宇号 -->
                <div v-if="isFullscreen" class="building-quick-switch">
                  <el-button
                    v-for="b in buildingOpts"
                    :key="b.id"
                    :type="dormBuildId === b.id ? 'primary' : 'default'"
                    size="small"
                    @click="dormBuildId = b.id; load()"
                  >
                    {{ b.dormBuildName }}
                  </el-button>
                  <el-button
                    :type="dormBuildId === null ? 'primary' : 'default'"
                    size="small"
                    @click="dormBuildId = null; load()"
                  >
                    全部
                  </el-button>
                </div>
                <el-tooltip content="全屏" placement="top">
                  <el-button :icon="isFullscreen ? 'FullScreen' : 'FullScreen'" style="width: 50px; margin-right: 10px" type="default" @click="toggleFullscreen"></el-button>
                </el-tooltip>
                <el-tooltip content="添加" placement="top" v-if="identity == 'admin'">
                  <el-button icon="plus" style="width: 50px" type="primary" @click="add"></el-button>
                </el-tooltip>
              </div>
            </el-form>
          </div>
        </div>
        <!-- 状态 -->
        <div class="status-row">
          <div class="status-item">
            <div class="tag"></div>
            <span>空房</span>
          </div>
          <div class="status-item">
            <div class="tag" style="background-color: #1ACAA8;"></div>
            <span>未满</span>
          </div>
          <div class="status-item">
            <div class="tag" style="background-color: #FF9461;"></div>
            <span>满房</span>
          </div>
          <div class="status-item">
            <div class="tag" style="background-color:rgb(121, 106, 106);"></div>
            <span>锁定</span>
          </div>
        </div>
        <!-- 房间类型图例 -->
        <div class="status-row" style="margin-top: 10px;">
          <div class="status-item">
            <div class="tag" style="background-color: #F56C6C;"></div>
            <span>问题房</span>
          </div>
          <div class="status-item">
            <div class="tag" style="background-color: #E6A23C;"></div>
            <span>值班室</span>
          </div>
          <div class="status-item">
            <div class="tag" style="background-color: #409EFF;"></div>
            <span>布草间</span>
          </div>
          <div class="status-item">
            <div class="tag" style="background-color: #67C23A;"></div>
            <span>洗衣房</span>
          </div>
          <div class="status-item">
            <div class="tag" style="background-color: #8e44ad;"></div>
            <span>教师收菜房</span>
          </div>
          <div class="status-item">
            <div class="tag" style="background-color: #909399;"></div>
            <span>会议室</span>
          </div>
          <div class="status-item">
            <div class="tag" style="background-color: #FF69B4;"></div>
            <span>套房</span>
          </div>
          <div class="status-item">
            <div class="tag" style="background-color: #FFFFFF; border: 1px solid #DCDFE6;"></div>
            <span>正常/空房</span>
          </div>
          <div class="status-item">
            <div class="tag" style="background-color: #FFFFFF; border: 1px solid #E6A23C; position: relative;">
              <span style="position: absolute; top: -6px; right: -4px; font-size: 10px; line-height: 1;">🔧</span>
            </div>
            <span>报修中</span>
          </div>
        </div>
        <!-- 班级颜色图例 -->
        <div v-if="classColorLegend.length > 0" class="status-row class-legend-row" style="margin-top: 8px;">
          <span style="font-weight: 500; color: #666; margin-right: 8px; font-size: 14px;">班级：</span>
          <div v-for="cls in classColorLegend" :key="cls.className" class="status-item" style="margin-right: 20px;">
            <div class="tag" :style="{ backgroundColor: cls.color }"></div>
            <span>{{ cls.className }}</span>
          </div>
        </div>
        <!-- 格子 -->
        <div class="main-content">
          <div class="building-section" v-for="(building, bIdx) in panelData" :key="bIdx">
            <div class="building-title">{{ building.buildingName }}</div>
            <div class="floor-row" v-for="(floorItem, fIdx) in building.floors" :key="fIdx">
              <div class="floor-name">{{ floorItem[0] }}层</div>
              <div class="floor-room-row">
                <el-popover placement="right" :width="380" trigger="click" v-for="(v, i) in floorItem[1]" :key="i">
                  <template #reference>
                    <div class="floor-room-row-item"
                      :class="{ 'status3': v.state == 3 }"
                      :style="{ backgroundColor: v.displayColor, color: v.textColor, borderColor: v.state == 3 ? '#999' : (v.displayColor !== '#FFFFFF' && v.displayColor !== '#ffffff' ? v.displayColor : '#E5E5E5') }">
                      <div class="room-id">{{ v.dormRoomId }}</div>
                      <div class="room-people">{{ v.bedNamesStr }}</div>
                      <!-- 报修标记 -->
                      <div v-if="v.repairs && v.repairs.length > 0" class="repair-badge" :title="'报修: ' + v.repairs.map(r => r.title || r.content).join(', ')">🔧</div>
                      <!-- 混住多班级时底部显示色块条纹 -->
                      <div v-if="v.classColors && v.classColors.length > 1" class="class-color-strip">
                        <span v-for="(cc, ci) in v.classColors" :key="ci" class="class-color-dot" :style="{ backgroundColor: cc.color }" :title="cc.className + '(' + cc.count + '人)'"></span>
                      </div>
                    </div>
                  </template>
                <div class="room-info-dialog">
                  <div class="room-info-dialog-title">房间信息
                    <el-tag v-if="v.status === '0' || v.status === 0" type="info">锁定</el-tag>
                    <el-tag v-else type="success">正常</el-tag>
                  </div>
                  <div class="room-info-dialog-wrap">
                    <div class="room-info-dialog-item">
                      <span>房间号：</span>
                      <span>{{ v.dormRoomId }}</span>
                    </div>
                    <div class="room-info-dialog-item">
                      <span>楼栋号：</span>
                      <span>{{ v.dormBuildId }}</span>
                    </div>
                    <div class="room-info-dialog-item">
                      <span>楼层：</span>
                      <span>{{ v.floorNum }}</span>
                    </div>
                    <div class="room-info-dialog-item">
                      <span>床位数：</span>
                      <span>{{ v.maxCapacity }}</span>
                    </div>
                    <div class="room-info-dialog-item">
                      <span>已住人数：</span>
                      <span>{{ v.currentCapacity }}</span>
                    </div>
                    <!-- 班级信息 -->
                    <div v-if="v.classColors && v.classColors.length > 0" class="room-info-dialog-item">
                      <span>入住班级：</span>
                      <span>
                        <el-tag v-for="(cc, ci) in v.classColors" :key="ci" :color="cc.color" style="color: #fff; margin: 2px;" size="small">{{ cc.className }}({{ cc.count }}人)</el-tag>
                      </span>
                    </div>
                    <!-- 床位学员列表 -->
                    <div v-if="v.currentCapacity > 0" class="room-info-dialog-item" style="flex-direction: column; align-items: flex-start;">
                      <span style="font-weight: 600; color: #333; margin-bottom: 6px;">入住学员：</span>
                      <div class="bed-list">
                        <div v-if="v.firstBedName" class="bed-item">
                          <span class="bed-label">1床</span>
                          <span class="bed-name">{{ v.firstBedName }}</span>
                          <el-popconfirm v-if="identity == 'admin'" title="确认退房？" @confirm="quickCheckOut(1, v)">
                            <template #reference><el-button type="danger" size="small" text>退房</el-button></template>
                          </el-popconfirm>
                        </div>
                        <div v-if="v.secondBedName" class="bed-item">
                          <span class="bed-label">2床</span>
                          <span class="bed-name">{{ v.secondBedName }}</span>
                          <el-popconfirm v-if="identity == 'admin'" title="确认退房？" @confirm="quickCheckOut(2, v)">
                            <template #reference><el-button type="danger" size="small" text>退房</el-button></template>
                          </el-popconfirm>
                        </div>
                        <div v-if="v.thirdBedName" class="bed-item">
                          <span class="bed-label">3床</span>
                          <span class="bed-name">{{ v.thirdBedName }}</span>
                          <el-popconfirm v-if="identity == 'admin'" title="确认退房？" @confirm="quickCheckOut(3, v)">
                            <template #reference><el-button type="danger" size="small" text>退房</el-button></template>
                          </el-popconfirm>
                        </div>
                        <div v-if="v.fourthBedName" class="bed-item">
                          <span class="bed-label">4床</span>
                          <span class="bed-name">{{ v.fourthBedName }}</span>
                          <el-popconfirm v-if="identity == 'admin'" title="确认退房？" @confirm="quickCheckOut(4, v)">
                            <template #reference><el-button type="danger" size="small" text>退房</el-button></template>
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                    <!-- 报修信息 -->
                    <div v-if="v.repairs && v.repairs.length > 0" class="room-info-dialog-item" style="flex-direction: column; align-items: flex-start;">
                      <span style="color: #E6A23C; font-weight: 600;">报修记录：</span>
                      <div v-for="(rp, ri) in v.repairs" :key="ri" style="margin-top: 4px; padding: 4px 8px; background: #fdf6ec; border-radius: 4px; width: 100%;">
                        <div style="font-size: 14px; color: #333;">
                          <el-tag type="warning" size="small" style="margin-right: 4px;">{{ rp.state }}</el-tag>
                          <span v-if="rp.title" style="font-weight: 500;">{{ rp.title }}</span>
                          <span v-else style="font-weight: 500;">{{ rp.content }}</span>
                        </div>
                        <div style="font-size: 12px; color: #999; margin-top: 2px;">
                          申请人: {{ rp.repairer }} | {{ rp.applyTime }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="room-info-dialog-item">
                    <el-button v-if="identity == 'admin'" type="primary" @click="handleEdit(v)">编辑</el-button>
                    <el-popconfirm v-if="identity == 'admin'" title="确认删除？" @confirm="handleDelete(v.dormRoomId)">
                      <template #reference>
                        <el-button type="danger">删除</el-button>
                      </template>
                    </el-popconfirm>
                    <el-button :disabled="v.state == 2 || v.state == 3" type="warning"
                      @click="handleCheckIn(v)">安排入住</el-button>
                  </div>
                </div>
              </el-popover>

            </div>
          </div>
          </div>
        </div>
        <!-- 弹窗-->
        <div>
          <!-- 编辑 -->
          <el-dialog v-model="dialogVisible" title="操作" width="30%" @close="cancel">
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
              <el-form-item label="楼栋号" prop="dormBuildId">
                <el-input v-model.number="form.dormBuildId" style="width: 80%"></el-input>
              </el-form-item>
              <el-form-item label="楼层数" prop="floorNum">
                <el-input v-model.number="form.floorNum" style="width: 80%"></el-input>
              </el-form-item>
              <el-form-item label="房间号" prop="dormRoomId">
                <el-input v-model.number="form.dormRoomId" :disabled="disabled" style="width: 80%"></el-input>
              </el-form-item>
              <el-form-item label="最多可住人数" prop="maxCapacity">
                <el-input v-model.number="form.maxCapacity" style="width: 80%"></el-input>
              </el-form-item>
              <el-form-item label="已住人数" prop="currentCapacity">
                <el-input v-model.number="form.currentCapacity" style="width: 80%"></el-input>
              </el-form-item>
              <el-form-item label="是否锁定" prop="currentCapacity">
                <el-radio-group v-model="form.status">
                  <el-radio value="0">是</el-radio>
                  <el-radio value="1">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
            <template #footer>
              <span class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
              </span>
            </template>
          </el-dialog>
          <!-- 安排入住 -->
          <el-dialog v-model="checkIndialogVisible" title="安排入住" width="30%" @close="cancelCheckIn">
            <el-form ref="formCheckIn" :model="checkInForm" :rules="checkInRules" label-width="120px">
              <el-form-item label="入住学员" prop="username">
                <el-select v-model="checkInForm.username" filterable remote reserve-keyword placeholder="请输入学员姓名"
                  :remote-method="remoteMethod" :loading="stuLoading" style="width: 90%">
                  <el-option v-for="item in stuOptions" :key="item.username" :label="item.name + '-' + item.username"
                    :value="item.username" />
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="当前宿舍">
                <el-input disabled v-model.number="checkInForm.currentDormInfo" style="width: 80%"></el-input>
              </el-form-item> -->
              <el-form-item label="目标宿舍">
                <el-input disabled :value="checkInForm.targetDormBuildId + '-' + checkInForm.targetDormRoomId"
                  style="width: 90%"></el-input>
              </el-form-item>
              <el-form-item label="目标床位" prop="targetDormBed">
                <el-select v-model="checkInForm.targetDormBed" placeholder="请选择床位" style="width: 90%">
                  <el-option v-for="item in bebOptions" :key="item.value" :label="item.label" :value="item.value"
                    :disabled="item.disabled" />
                </el-select>
              </el-form-item>
            </el-form>
            <template #footer>
              <span class="dialog-footer">
                <el-button @click="cancelCheckIn">取 消</el-button>
                <el-button type="warning" @click="addStuBed">确认入住</el-button>
              </span>
            </template>
          </el-dialog>
          <!-- 床位 弹窗-->
          <el-dialog v-model="bedDialog" title="操作" width="30%" @close="cancel">
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
              <el-form-item label="楼栋号" prop="dormBuildId">
                <el-input v-model.number="form.dormBuildId" disabled="true" style="width: 80%"></el-input>
              </el-form-item>
              <el-form-item label="楼层数" prop="floorNum">
                <el-input v-model.number="form.floorNum" disabled="true" style="width: 80%"></el-input>
              </el-form-item>
              <el-form-item label="房间号" prop="dormRoomId">
                <el-input v-model.number="form.dormRoomId" disabled="true" style="width: 80%"></el-input>
              </el-form-item>
              <el-form-item v-if="this.bedNum === 1" label="床位(一)" prop="firstBed">
                <el-input v-model.number="form.firstBed" placeholder="请输入学号" style="width: 80%"></el-input>
              </el-form-item>
              <el-form-item v-if="this.bedNum === 2" label="床位(二)" prop="secondBed">
                <el-input v-model.number="form.secondBed" placeholder="请输入学号" style="width: 80%"></el-input>
              </el-form-item>
              <el-form-item v-if="this.bedNum === 3" label="床位(三)" prop="thirdBed">
                <el-input v-model.number="form.thirdBed" placeholder="请输入学号" style="width: 80%"></el-input>
              </el-form-item>
              <el-form-item v-if="this.bedNum === 4" label="床位(四)" prop="fourthBed">
                <el-input v-model.number="form.fourthBed" placeholder="请输入学号" style="width: 80%"></el-input>
              </el-form-item>
            </el-form>
            <template #footer>
              <span class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button v-if="this.judge === false" type="primary" @click="addStuBed">确 定</el-button>
                <el-button v-if="this.judge === true" type="primary" @click="editStuBed">确 定</el-button>
              </span>
            </template>
          </el-dialog>
          <!-- 学员信息弹窗-->
          <el-dialog v-model="stuInfoDialog" title="学生信息" width="20%" @close="cancel">
            <el-form ref="form" :model="form" label-width="120px">
              <el-form-item label="学号：" prop="username">
                <template #default="scope">
                  <span>{{ form.username }}</span>
                </template>
              </el-form-item>
              <el-form-item label="姓名：" prop="name">
                <template #default="scope">
                  <span>{{ form.name }}</span>
                </template>
              </el-form-item>
              <el-form-item label="年龄：" prop="age">
                <template #default="scope">
                  <span>{{ form.age }}</span>
                </template>
              </el-form-item>
              <el-form-item label="性别：" prop="gender">
                <template #default="scope">
                  <span>{{ form.gender }}</span>
                </template>
              </el-form-item>
              <el-form-item label="手机号：" prop="phoneNum">
                <template #default="scope">
                  <span>{{ form.phoneNum }}</span>
                </template>
              </el-form-item>
              <el-form-item label="邮箱地址：" prop="email">
                <template #default="scope">
                  <span>{{ form.email }}</span>
                </template>
              </el-form-item>
            </el-form>
          </el-dialog>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script src="@/assets/js/RoomPanel.js"></script>
<style>
@import '../assets/css/RoomInfo.css';

.status-row {
  display: flex;
}

.status-row .status-item {
  display: flex;
  align-items: center;
  margin-right: 30px;
}

.status-row .status-item .tag {
  width: 36px;
  height: 20px;
  background: #FFFFFF;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #E5E5E5;
  margin-right: 6px;
}

.status-row .status-item span {
  font-weight: 500;
  font-size: 16px;
  color: #666666;
}

.building-section {
  margin-bottom: 10px;
}

.building-title {
  font-weight: bold;
  font-size: 13px;
  color: #333;
  padding: 3px 8px;
  background: #f0f9eb;
  border-left: 3px solid #67C23A;
  margin-bottom: 6px;
  border-radius: 3px;
}

.floor-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
}

.floor-row .floor-name {
  font-weight: 500;
  font-size: 12px;
  color: #666;
  width: 36px;
  padding-left: 4px;
  padding-top: 4px;
  flex-shrink: 0;
}

.floor-row .floor-room-row {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(72px, 1fr));
  gap: 4px;
  flex: 1;
}

.floor-row .floor-r11oom-row::-webkit-scrollbar {
  display: none;
}

.floor-room-row-item {
  min-width: 0;
  height: 36px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #E5E5E5;
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 3px;
  transition: transform 0.15s, box-shadow 0.15s;
}

.room-id {
  font-size: 11px;
  font-weight: bold;
  line-height: 1.2;
}

.room-people {
  font-size: 9px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.floor-room-row-item:hover {
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
  transform: scale(1.05);
  transition: transform 0.15s;
}

.status1 {
  background: #1ACAA8 !important;
  color: #FFFFFF !important;
}

.status2 {
  background: #FF9461 !important;
  color: #FFFFFF !important;
}

.status3 {
  background: rgb(121, 106, 106);
  color: #FFFFFF;
}

.main-content {
  padding: 8px 0;
  overflow: hidden;
}

.el-card {
  overflow: hidden;
}

.el-card__body {
  overflow: hidden;
}

.status-row {
  display: flex;
}

.status-row .status-item {
  display: flex;
  align-items: center;
  margin-right: 30px;
}

.status-row .status-item .tag {
  width: 36px;
  height: 20px;
  background: #FFFFFF;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #E5E5E5;
  margin-right: 6px;
}

.status-row .status-item span {
  font-weight: 500;
  font-size: 16px;
  color: #666666;
}

.building-section {
  margin-bottom: 10px;
}

.building-title {
  font-weight: bold;
  font-size: 13px;
  color: #333;
  padding: 3px 8px;
  background: #f0f9eb;
  border-left: 3px solid #67C23A;
  margin-bottom: 6px;
  border-radius: 3px;
}

.floor-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
}

.floor-row .floor-name {
  font-weight: 500;
  font-size: 12px;
  color: #666;
  width: 36px;
  padding-left: 4px;
  padding-top: 4px;
  flex-shrink: 0;
}

.floor-row .floor-room-row {
  display: grid !important;
  grid-template-columns: repeat(auto-fill, minmax(72px, 1fr)) !important;
  gap: 4px;
  flex: 1;
}

.floor-room-row-item {
  min-width: 0;
  height: 36px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #E5E5E5;
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 3px;
  transition: transform 0.15s, box-shadow 0.15s;
}

.room-id {
  font-size: 11px;
  font-weight: bold;
  line-height: 1.2;
}

.room-people {
  font-size: 9px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.floor-room-row-item:hover {
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
  transform: scale(1.05);
  transition: transform 0.15s;
}

.status1 {
  background: #1ACAA8 !important;
  color: #FFFFFF !important;
}

.status2 {
  background: #FF9461 !important;
  color: #FFFFFF !important;
}

.status3 {
  background: rgb(121, 106, 106);
  color: #FFFFFF;
}

.main-content {
  padding: 8px 0;
}

/* 小屏幕适配（高度 < 700px） */
@media screen and (max-height: 700px) {
  .floor-room-row-item {
    height: 30px;
  }
  .room-id {
    font-size: 10px;
  }
  .room-people {
    font-size: 8px;
  }
  .building-title {
    font-size: 11px;
    padding: 2px 6px;
    margin-bottom: 4px;
  }
  .floor-row {
    margin-bottom: 4px;
  }
  .floor-row .floor-name {
    font-size: 10px;
    width: 28px;
  }
}

/* 大屏幕适配（高度 > 900px） */
@media screen and (min-height: 900px) {
  .floor-room-row-item {
    height: 42px;
  }
  .room-id {
    font-size: 12px;
  }
  .room-people {
    font-size: 10px;
  }
  .building-title {
    font-size: 14px;
    padding: 4px 10px;
  }
  .floor-row .floor-name {
    font-size: 13px;
    width: 40px;
  }
}

/* 超宽屏幕适配 */
@media screen and (min-width: 1600px) {
  .floor-row .floor-room-row {
    grid-template-columns: repeat(auto-fill, minmax(85px, 1fr)) !important;
  }
  .floor-room-row-item {
    height: 42px;
  }
  .room-id {
    font-size: 12px;
  }
  .room-people {
    font-size: 10px;
  }
}

/* 窄屏幕适配 */
@media screen and (max-width: 768px) {
  .room-panel-card {
    margin: 8px !important;
  }

  .panel-search-form {
    display: flex;
    flex-wrap: wrap;
    gap: 0;
  }

  .panel-search-form .build-select-item {
    margin-right: 0 !important;
    margin-bottom: 8px;
    width: 100%;
  }

  .panel-search-form .build-select-item .el-select {
    width: 100% !important;
  }

  .panel-search-form .build-btn-item {
    margin-bottom: 8px;
  }

  .build-actions {
    float: none !important;
    width: 100%;
    justify-content: flex-end;
    margin-top: 4px;
  }

  .building-quick-switch {
    display: none !important;
  }

  /* 图例精简 */
  .status-row {
    flex-wrap: wrap;
    gap: 4px 0;
  }

  .status-row .status-item {
    margin-right: 12px !important;
  }

  .status-row .status-item .tag {
    width: 24px;
    height: 14px;
  }

  .status-row .status-item span {
    font-size: 12px;
  }

  .class-legend-row {
    flex-wrap: wrap;
  }

  .class-legend-row .status-item {
    margin-right: 10px !important;
  }

  /* 房间格子列表模式 */
  .floor-row .floor-room-row {
    grid-template-columns: repeat(auto-fill, minmax(60px, 1fr)) !important;
    gap: 3px;
  }

  .floor-room-row-item {
    height: 32px;
    padding: 0 2px;
  }

  .room-id {
    font-size: 10px;
  }

  .room-people {
    font-size: 7px;
  }

  .floor-row .floor-name {
    font-size: 10px;
    width: 28px;
  }

  .building-title {
    font-size: 12px;
    padding: 2px 6px;
    margin-bottom: 4px;
  }

  .floor-row {
    margin-bottom: 4px;
  }

  /* 弹窗宽度自适应 */
  .el-dialog {
    width: 92% !important;
    margin-top: 5vh !important;
  }

  /* Popover宽度 */
  .el-popover {
    max-width: calc(100vw - 30px) !important;
  }

  .room-info-dialog-title {
    font-size: 16px;
  }

  .room-info-dialog-item span {
    font-size: 14px;
  }

  .repair-badge {
    font-size: 8px;
  }

  .class-color-dot {
    width: 6px;
    height: 3px;
  }
}

.room-info-dialog {
  padding: 10px;
}

.room-info-dialog-title {
  font-weight: bold;
  font-size: 20px;
  color: #333333;
  margin-bottom: 10px;
}

.room-info-dialog-wrap {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0;
}

.room-info-dialog-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 30px;
}

.room-info-dialog-item span {
  font-weight: 500;
  font-size: 16px;
  color: #666666;
}

/* 床位学员列表 */
.bed-list {
  width: 100%;
}
.bed-item {
  display: flex;
  align-items: center;
  padding: 6px 8px;
  margin-bottom: 4px;
  background: #f5f7fa;
  border-radius: 4px;
}
.bed-item .bed-label {
  font-size: 12px;
  color: #909399;
  margin-right: 8px;
  min-width: 30px;
  font-weight: 600;
}
.bed-item .bed-name {
  flex: 1;
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

/* 楼宇号快速切换按钮组 */
.building-quick-switch {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  margin-right: 10px;
}

/* 混住多班级色块条纹 */
.class-color-strip {
  display: flex;
  gap: 2px;
  justify-content: center;
  margin-top: 1px;
}

.class-color-dot {
  width: 8px;
  height: 4px;
  border-radius: 2px;
  display: inline-block;
}

/* 报修标记 */
.repair-badge {
  position: absolute;
  top: 1px;
  right: 1px;
  font-size: 9px;
  line-height: 1;
  z-index: 1;
}

.floor-room-row-item {
  position: relative;
}

/* 全屏模式样式 - 紧凑布局 */
:fullscreen .el-card {
  margin: 0 !important;
  border-radius: 0 !important;
  height: 100vh !important;
  min-height: 100vh !important;
  overflow: hidden !important;
}

:fullscreen .el-card__body {
  padding: 10px !important;
  height: 100% !important;
  overflow: hidden !important;
}

:fullscreen .main-content {
  padding: 10px 0;
  height: auto !important;
  max-height: none !important;
  overflow-y: visible !important;
}

:fullscreen .floor-row .floor-room-row {
  grid-template-columns: repeat(auto-fill, minmax(85px, 1fr)) !important;
  gap: 5px;
}

:fullscreen .floor-room-row-item {
  min-width: 0;
  height: 48px;
}

:fullscreen .room-id {
  font-size: 13px;
}

:fullscreen .room-people {
  font-size: 11px;
}

:fullscreen .floor-room-row-item {
  min-width: 0;
  height: 42px;
}

:fullscreen .building-section {
  margin-bottom: 12px;
}

:fullscreen .building-title {
  font-size: 14px;
  padding: 4px 10px;
  margin-bottom: 8px;
}

:fullscreen .floor-row {
  margin-bottom: 10px;
}

:fullscreen .floor-row .floor-name {
  font-size: 13px;
  width: 40px;
}

/* WebKit 全屏前缀 */
:-webkit-full-screen .el-card {
  margin: 0 !important;
  border-radius: 0 !important;
  height: 100vh !important;
  min-height: 100vh !important;
  overflow-y: auto !important;
}

:-webkit-full-screen .el-card__body {
  padding: 10px !important;
  height: 100% !important;
  overflow-y: auto !important;
}

:-webkit-full-screen .main-content {
  padding: 10px 0;
  height: auto !important;
  max-height: none !important;
  overflow-y: visible !important;
}

:-webkit-full-screen .floor-row .floor-room-row {
  grid-template-columns: repeat(auto-fill, minmax(85px, 1fr)) !important;
  gap: 5px;
}

:-webkit-full-screen .floor-room-row-item {
  min-width: 0;
  height: 48px;
}

:-webkit-full-screen .room-id {
  font-size: 13px;
}

:-webkit-full-screen .room-people {
  font-size: 11px;
}

:-webkit-full-screen .floor-room-row-item {
  min-width: 0;
  height: 42px;
}

:-webkit-full-screen .building-section {
  margin-bottom: 12px;
}

:-webkit-full-screen .building-title {
  font-size: 14px;
  padding: 4px 10px;
  margin-bottom: 8px;
}

:-webkit-full-screen .floor-row {
  margin-bottom: 10px;
}

:-webkit-full-screen .floor-row .floor-name {
  font-size: 13px;
  width: 40px;
}
@media screen and (max-height: 700px) {
  .floor-room-row-item {
    height: 30px;
  }
  .room-id {
    font-size: 10px;
  }
  .room-people {
    font-size: 8px;
  }
  .building-title {
    font-size: 11px;
    padding: 2px 6px;
    margin-bottom: 4px;
  }
  .floor-row {
    margin-bottom: 4px;
  }
  .floor-row .floor-name {
    font-size: 10px;
    width: 28px;
  }
}

/* 大屏幕适配（高度 > 900px） */
@media screen and (min-height: 900px) {
  .floor-room-row-item {
    height: 42px;
  }
  .room-id {
    font-size: 12px;
  }
  .room-people {
    font-size: 10px;
  }
  .building-title {
    font-size: 14px;
    padding: 4px 10px;
  }
  .floor-row .floor-name {
    font-size: 13px;
    width: 40px;
  }
}

/* 超宽屏幕适配 */
@media screen and (min-width: 1600px) {
  .floor-row .floor-room-row {
    grid-template-columns: repeat(auto-fill, minmax(85px, 1fr));
  }
  .floor-room-row-item {
    height: 42px;
  }
  .room-id {
    font-size: 12px;
  }
  .room-people {
    font-size: 10px;
  }
}

.room-info-dialog {
  padding: 10px;
}

.room-info-dialog-title {
  font-weight: bold;
  font-size: 20px;
  color: #333333;
  margin-bottom: 10px;
}

.room-info-dialog-wrap {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0;
}

.room-info-dialog-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 30px;
}

.room-info-dialog-item span {
  font-weight: 500;
  font-size: 16px;
  color: #666666;
}

/* 全屏模式样式 - 紧凑布局 */
:fullscreen .el-card {
  margin: 0 !important;
  border-radius: 0 !important;
  height: 100vh !important;
  min-height: 100vh !important;
  overflow-y: auto !important;
}

:fullscreen .main-content {
  padding: 10px 0;
  height: auto !important;
  max-height: none !important;
  overflow-y: visible !important;
}

:fullscreen .floor-row .floor-room-row {
  grid-template-columns: repeat(auto-fill, minmax(85px, 1fr));
  gap: 5px;
}

:fullscreen .floor-room-row-item {
  min-width: 0;
  height: 48px;
}

:fullscreen .room-id {
  font-size: 13px;
}

:fullscreen .room-people {
  font-size: 11px;
}

:fullscreen .floor-room-row-item {
  min-width: 0;
  height: 42px;
}

:fullscreen .building-section {
  margin-bottom: 12px;
}

:fullscreen .building-title {
  font-size: 14px;
  padding: 4px 10px;
  margin-bottom: 8px;
}

:fullscreen .floor-row {
  margin-bottom: 10px;
}

:fullscreen .floor-row .floor-name {
  font-size: 13px;
  width: 40px;
}

/* WebKit 全屏前缀 */
:-webkit-full-screen .el-card {
  margin: 0 !important;
  border-radius: 0 !important;
  height: 100vh !important;
  min-height: 100vh !important;
  overflow-y: auto !important;
}

:-webkit-full-screen .main-content {
  padding: 10px 0;
  height: auto !important;
  max-height: none !important;
  overflow-y: visible !important;
}

:-webkit-full-screen .floor-row .floor-room-row {
  grid-template-columns: repeat(auto-fill, minmax(85px, 1fr));
  gap: 5px;
}

:-webkit-full-screen .floor-room-row-item {
  min-width: 0;
  height: 48px;
}

:-webkit-full-screen .room-id {
  font-size: 13px;
}

:-webkit-full-screen .room-people {
  font-size: 11px;
}

:-webkit-full-screen .floor-room-row-item {
  min-width: 0;
  height: 42px;
}

:-webkit-full-screen .building-section {
  margin-bottom: 12px;
}

:-webkit-full-screen .building-title {
  font-size: 14px;
  padding: 4px 10px;
  margin-bottom: 8px;
}

:-webkit-full-screen .floor-row {
  margin-bottom: 10px;
}

:-webkit-full-screen .floor-row .floor-name {
  font-size: 13px;
  width: 40px;
}
</style>